import React from "react";
import styled, {css} from "styled-components";
import breakpoints from "Helpers/BreakpointHelper";
import media from "styled-media-query";
import {HitWrapper} from "Components/Search/hits";

export const BaseHeader = styled.span.attrs(
  ({
     font,
     color,
     marginsmall,
     margin,
     size,
     theme,
     fontWeight,
     textTransform,
     maxWidth,
     forceLargeFontSize,
     whiteSpace,
   }) => ({
    fontSize: size ? size : "",
    color: color ? color : theme.colors.black,
    marginSmall: marginsmall ? marginsmall : margin ? margin : 0,
    margin: margin ? margin : 0,
    fontWeight: fontWeight ? fontWeight : "500",
    textTransform: textTransform ? textTransform : undefined,
    maxwidth: maxWidth ? maxWidth : "none",
    forceLargeFontSize: forceLargeFontSize ? forceLargeFontSize : undefined,
    whiteSpace: whiteSpace ? whiteSpace : undefined,
  })
)`
    font-size: ${({fontSize}) => (fontSize ? fontSize : "")};
    font-family: ${({font, theme}) => (font ? font : theme.font)};
    color: ${({color}) => color};
    font-weight: ${({fontWeight}) => fontWeight};
    margin: ${({marginSmall}) => marginSmall};
    text-align: ${({textAlign}) => textAlign};
    max-width: ${({maxwidth}) => maxwidth};
    ${({whiteSpace}) =>
            whiteSpace &&
            css`
                white-space ${({whiteSpace}) => whiteSpace};
            `}
    ${({textTransform}) =>
            textTransform &&
            css`
                text-transform: ${({textTransform}) => textTransform};
            `}
    ${media.greaterThan(breakpoints.ipad)`
    	margin: ${({margin}) => margin};
      ${({forceLargeFontSize}) =>
            forceLargeFontSize &&
            css`
                font-size ${({forceLargeFontSize}) =>
                        forceLargeFontSize} !important;
            `}
  	`}
`;

export const H1 = styled(BaseHeader).attrs(({lineHeight, margin}) => ({
  as: "h1",
  id: "h1",
  lineHeight: lineHeight ? lineHeight : "",
  margin: margin ? margin : "",
}))`
    margin: ${({margin}) => (margin ? margin : "0 0 30px 0")};
    font-size: 36px;
    line-height: ${({lineHeight}) => (lineHeight ? lineHeight : "42px")};
    ${media.greaterThan(breakpoints.ipad)`
		font-size: 50px;
		line-height: 56px;
  	`};
`;

export const H2 = styled(BaseHeader).attrs(
  ({smallLineHeight, smallFontSize, size}) => ({
    as: "h2",
    smallFontSize: smallFontSize ? smallFontSize : "24px",
    smallLineHeight: smallLineHeight ? smallLineHeight : "30px",
    fontSize: size ? size : "32px",
  })
)`
    font-size: ${({smallFontSize}) => smallFontSize};
    line-height: ${({smallLineHeight}) => smallLineHeight};

    & {
        text-align: ${({align}) => (align ? align : "")};
    }

    ${media.greaterThan(breakpoints.ipad)`
		font-size: ${({size}) => size};
		line-height: 38px;
	`}
`;

export const H3 = styled(BaseHeader).attrs(
  ({mobileFontSize, mobileLineHeight, tabletFontSize, tabletLineHeight}) => ({
    as: "h3",
    mobileFontSize: mobileFontSize ? mobileFontSize : "20px",
    mobileLineHeight: mobileLineHeight ? mobileLineHeight : "26px",
    tabletFontSize: tabletFontSize ? tabletFontSize : "20px",
    tabletLineHeight: tabletLineHeight ? tabletLineHeight : "26px",
  })
)`
    font-size: ${({mobileFontSize}) => mobileFontSize};
    line-height: ${({mobileLineHeight}) => mobileLineHeight};

    ${media.greaterThan(breakpoints.mobile)`
    font-size: ${({tabletFontSize}) => tabletFontSize};
    line-height: ${({tabletLineHeight}) => tabletLineHeight}; 
  `}

    ${media.greaterThan(breakpoints.ipad)`
		font-size: 24px;
		line-height: 30px;
	`}
`;

export const H4 = styled(BaseHeader).attrs({
  as: "h4",
})`
    font-size: 18px;
    line-height: 24px;

    ${media.greaterThan(breakpoints.ipad)`
		font-size: 20px;
		line-height: 24px;
  	`}
`;
